import { render } from "./AuthContent.vue?vue&type=template&id=d58ec33c"
import script from "./AuthContent.vue?vue&type=script&lang=js"
export * from "./AuthContent.vue?vue&type=script&lang=js"
script.render = render

export default script